// extracted by mini-css-extract-plugin
export default {"wrap":"EmailTemplatePreview_wrap__FvM4y","content":"EmailTemplatePreview_content__7Cnyv"};